import { MIMETYPE_JSON } from '@disy/lib/media-type';

import { ajax } from 'cadenza/api-client/api';
import type { MutableReferenceSystemDto, ReferenceSystemDto } from 'cadenza/api-client/model/reference-system-dto';
import type { ReferenceSystemId } from 'cadenza/api-client/model/reference-system-id.gen';
import type { ReferenceSystemSettingsDto } from 'cadenza/api-client/model/reference-system-settings-dto';

export function getReferenceSystemList() {
  return ajax<ReferenceSystemDto[]>('/reference-systems');
}

export function getReferenceSystem(id: ReferenceSystemId) {
  return ajax<ReferenceSystemDto>(`/reference-systems/${id}`);
}

export function saveReferenceSystem(referenceSystemDto: MutableReferenceSystemDto) {
  return ajax<ReferenceSystemDto>('/reference-systems', {
    method: 'POST',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify(referenceSystemDto),
  });
}

export function updateReferenceSystem(id: ReferenceSystemId, referenceSystemDto: ReferenceSystemDto) {
  return ajax<ReferenceSystemDto>(`/reference-systems/${id}`, {
    method: 'PUT',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify(referenceSystemDto),
  });
}

export function deleteReferenceSystem(referenceSystemId: ReferenceSystemId) {
  return ajax<void>(`/reference-systems/${referenceSystemId}`, {
    method: 'DELETE',
  });
}

export function moveReferenceSystemUp(referenceSystemId: ReferenceSystemId) {
  return ajax<ReferenceSystemDto>(`/reference-systems/${referenceSystemId}/move-up`, {
    method: 'PUT',
  });
}

export function moveReferenceSystemDown(referenceSystemId: ReferenceSystemId) {
  return ajax<ReferenceSystemDto>(`/reference-systems/${referenceSystemId}/move-down`, {
    method: 'PUT',
  });
}

export function getReferenceSystemSettings() {
  return ajax<ReferenceSystemSettingsDto>('/config/reference-system');
}

export function updateReferenceSystemSettings(referenceSystemSettingsDto: ReferenceSystemSettingsDto) {
  return ajax<ReferenceSystemSettingsDto>('/config/reference-system', {
    method: 'PUT',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify(referenceSystemSettingsDto),
  });
}
